import Vue    from 'vue'
import Vuex   from 'vuex'
import { setToken } from "@/api/client"
import { setGroupIdHeader, setSemesterIdHeader } from "@/api/helpers"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        debug         : window.location.href.startsWith("http://127.0.0.1") || window.location.href.startsWith("http://scgroup.com"),
        theme         : "theme-none",
        group         : {},
        semester      : {},
        settings      : {},
        permissions   : {},
        cached_roles  : {},
        user          : null,
        students      : null,
        app           : {},
        redirect      : "",
        current_site  : null,
        loggedIn      : false,
        appLoaded     : false,
        token         : localStorage.getItem("token") || "",
        loading       : true
    },
    mutations: {
        login (state, payload) {
            if (state.debug) console.log('setUserData payload = ', payload)
            state.user          = payload.user;
            state.students      = payload.students;
            state.settings      = { ...state.settings, ...payload.settings };
            state.permissions   = payload.permissions;
            state.loggedIn      = !(state.user == null);
            state.appLoaded     = true;
            state.token         = payload.token;
        },
        updateStudent (state, payload) {
            if (state.debug) console.log('updateStudent payload = ', payload);

            let student = state.students.find((student) => student.id == payload.id);
            if (student) {
                let studentIndex = state.students.findIndex((student) => student.id == payload.id);
                state.students[studentIndex] = payload;
            } else {
                state.students.push(payload);
            }
        },
        removeStudent (state, payload) {
            for(var index = 0; index < state.students.length; index++) {
                if (state.students[index].id == payload.id) {
                    delete state.students[index];
                    return;
                }
            }
        },
        updateStudents (state, payload) {
            state.students      = payload.students;
        },
        updateSettings(state, payload) {
            state.settings = { ...state.settings, ...payload };
        },
        setRole (state, payload) {
            state.cached_roles = { ...state.cached_roles, ...payload };
        },
        setSemester (state, semester_payload) {
            state.semester = semester_payload || {};

            if (semester_payload) {
                // Set settings for ALLOW_REGISTRATION
                this.commit("updateSettings", { ALLOW_REGISTRATION: semester_payload.registration_open == 1 });

                setSemesterIdHeader(semester_payload.id);
            }
        },
        setGroup (state, payload) {
            state.group = payload;
            setGroupIdHeader(payload.group_id);
        },
        logout (state) {
            localStorage.clear();
            sessionStorage.clear();
            state.user      = null;
            state.students  = null;
            state.semester  = {};
            state.loggedIn  = false;
            state.token     = "";
            setToken("");
        },
        changeDebugMode(state, payload) {
            state.debug = payload;
        },
        setLoading(state, payload) {
            state.loading = payload;
        }
    },
    getters: {
        name (state) {
            if (state.user.person) {
                return `${state.user.person.first_name} ${state.user.person.last_name}`
            }
        }
    }
})
